import React from "react";
import styled from "@emotion/styled";
import UnlockIcon from "@atlaskit/icon/glyph/unlock";
import LockIcon from "@atlaskit/icon/glyph/lock";
import { UserRoommateLockModal } from "../UserRoommateLockModal/UserRoommateLockModal";
import { useModalContext } from "../../contexts/ModalContext/context";

import { Button } from "../../UI/Button";

const StyledButton = styled(Button)`
  height: 39px !important;
  align-items: center !important;
  margin-right: 10px;
`;

export interface IProps {
  l1Id?: number | null;
  l2Id?: number | null;
  l3Id?: number | null;
  results: any[];
  membershipIds?: string[];
  membershipIdsGroups?: string[][];
  isDisabled?: boolean;
  onSuccess: VoidFunction;
}

const LOCK_IN = "Lock in Matches";
const UNLOCK = "Unlock Matches";

export const LockUnlockButtonGroup: React.FC<IProps> = (props) => {
  const [adminLock, setAdminLock] = React.useState(false);
  const [userIds, setUserIds] = React.useState<Array<string>>([]);
  const { setIsOpen } = useModalContext();



  const handleLockClick = () => {
    setAdminLock(false);
    setIsOpen(true);
  };

  const handleUnlockClick = () => {
    setAdminLock(true);
    setIsOpen(true);
  };

  React.useEffect(() => {
    setAdminLock(false);
    const ids= props.results.map(user => user.uid);
    setUserIds(ids);
  }, [props.results]);

  return (
    <>
      <StyledButton
        size={39}
        isDisabled={props.isDisabled || userIds.length === 0}
        appearance="primary"
        onClick={handleLockClick}
        iconBefore={<LockIcon label="Lock in Matches" />}
      >
        {LOCK_IN}
      </StyledButton>
      <StyledButton
        size={39}
        isDisabled={props.isDisabled || userIds.length === 0}
        appearance="primary"
        onClick={handleUnlockClick}
        iconBefore={<UnlockIcon label="Unlock Matches" />}
      >
        {UNLOCK}
      </StyledButton>
        <UserRoommateLockModal
          l1Id={props.l1Id}
          l2Id={props.l2Id}
          l3Id={props.l3Id}
          adminLock={adminLock}
          lockUnlockAllUsers
          onSuccess={props.onSuccess}
        />
    </>
  );
};

LockUnlockButtonGroup.defaultProps = {
  isDisabled: false,
};
